import React, { useEffect, useState } from 'react';
import { Card, Grid, Paper, SelectChangeEvent } from '@mui/material';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import { useLocation, useNavigate } from 'react-router-dom';
import { BakeasyImgSelectorView } from '../../components/common/BakeasyImgSelect';
import { t } from 'i18next';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { clearCategoryState } from '../../redux_store/slices/categorySlice';
import { clearSubCategoryState } from '../../redux_store/slices/subCategorySlice';
import {
  downloadProductDetails,
  fetchProductById,
  productsState,
} from '../../redux_store/slices/productsSlice';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import { UNAUTHORIZED } from '../../constants/Constants';
import { authActions } from '../../redux_store/slices/authSlice';
import * as Button from '../../components/buttons/BakeasyButtons';
import BakeasyLabelText from '../../components/labels/BakeasyLabelText';
import { AppContext } from '../../context/AppContext';
import { getCurrency } from '../../utils/commonUtils';
import { storeState } from '../../redux_store/slices/storeSlice';

export const ProductDetails = (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(true);

  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [selectedCategory, setSelectedCategory] = useState<any>(undefined);
  const [selectedSubCategory, setSelectedSubCategory] =
    useState<any>(undefined);
  const [selectedProductType, setSelectedProductType] = useState<any>('');
  const [recipeBuilder, setRecipeBuilder] = useState<any>('');
  const [recipeBuilderType, setRecipeBuilderType] = useState<any>('');
  const [ingredientList, setIngredientList] = useState<any[]>([]);
  const [description, setDescription] = useState<any>('');

  const [productName, setProductName] = useState<any>('');
  const [productId, setProductId] = useState<any>('');
  const [retailPrice, setRetailPrice] = useState<any>(0);
  const [ingredientName, setIngredientName] = useState<any>('');
  const [productCost, setProductCost] = useState<any>('');

  const [unitsOfMeasure, setUnitsOfMeasure] = useState<any>('');
  const unitsOfMeasureOptions = ['kg', 'grams', 'litre'];
  const [ingQuantity, setIngQuantity] = useState<any>('');
  const [storeCost, setStoreCost] = useState<any>(0);

  const [skuNumber, setSkuNumber] = useState<any>('');
  const [selectedProductImageFile, setSelectedProductImageFile] = useState<
    File | string | null
  >(null);
  const [selectedIngredientImage, setSelectedIngredientImage] = useState<
    File | string | null
  >(null);
  const [selectedNutritionImage, setSelectedNutritionImage] = useState<
    File | string | null
  >(null);
  const [skuImage, setSelectedSkuImage] = useState<File | string | null>(null);
  const [qrCode, setSelectedQrCode] = useState<File | string | null>(null);

  let { loading, error, value, rowsPerPage, pageNo, selectedValue } =
    useAppSelector(productsState);

  const [productData, setProductData] = useState<any>();

  let _storeState = useAppSelector(storeState);

  useEffect(() => {
    setIsEdit(location?.state?.isEdit);
    setIsView(location?.state?.isView);

    if (location?.state?.isEdit === true || location?.state?.isView === true) {
      fetchData(location?.state?._id);
    }
  }, []);

  useEffect(() => {
    if (selectedValue) {
      setProductData(selectedValue[0]);
      setData(selectedValue[0]);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (error === UNAUTHORIZED) {
      dispatch(authActions.logout());
    }
  }, [error]);

  useEffect(() => {
    dispatch(clearCategoryState());
    dispatch(clearSubCategoryState());
  }, [isEdit]);

  const fetchData = async (_id: any) => {
    dispatch(fetchProductById({ id: _id }));
  };

  async function setData(data: any) {
    setProductId(data.userProductId);
    setProductName(data.productName);
    setSelectedStatus(data.status);

    setSelectedCategory({
      _id: data?.categoryId,
      categoryName: data?.categoryName,
    });
    setSelectedSubCategory({
      _id: data?.categoryId,
      subCategoryName: data?.subCategoryName,
    });

    setSelectedProductType(data.productType);
    setRetailPrice(data.price);
    setStoreCost(parseFloat(data.storeCost).toFixed(2));
    setDescription(data.description);
    setSkuNumber(data.productSKU);
    setRecipeBuilder(data.isReceipeBuilder ? 'Yes' : 'No');
    setRecipeBuilderType(data.receipeBuilderType);

    if (data.productType === 'Manufactured' && data.ingredients) {
      const Ingredients = data.ingredients.map((item: any) => ({
        ingredientId: item.ingredientId,
        ingredientName: item?.ingredientName,
        units: item.quantity,
        measureType: item.unit,
        price: item.price,
        totalPrice: (Number(item.units) * Number(item.price)).toFixed(2),
      }));
      setIngredientList(Ingredients);
    } else {
      setIngredientList([]);
    }

    setSelectedProductImageFile(
      data?.documents?.find((doc: any) => doc?.type === 'productImage')?.fileURL
    );
    setSelectedIngredientImage(
      data?.documents?.find((doc: any) => doc?.type === 'ingredientLabel')
        ?.fileURL
    );
    setSelectedNutritionImage(
      data?.documents?.find((doc: any) => doc?.type === 'nutritionLabel')
        ?.fileURL
    );
    setSelectedSkuImage(
      data?.documents?.find((doc: any) => doc?.type === 'SKUImage')?.fileURL
    );
    setSelectedQrCode(
      data?.documents?.find((doc: any) => doc?.type === 'QRCode')?.fileURL
    );

    setProductCost(parseFloat(data.productCost).toFixed(2));
  }

  function openImageDialog(pageName: string, title: string, imgUrl: any) {
    return myContext.setDialog({
      open: true,
      title,
      dialogContent: { pageName, imgUrl, title },
    });
  }

  function getMenus() {
    return (
      <Grid>
        {isView && (
          <div className="tableOptions">
            <Button.Print
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                dispatch(
                  downloadProductDetails({
                    id: location?.state?._id,
                    downloadType: 'pdf',
                  })
                );
              }}
            />
          </div>
        )}
      </Grid>
    );
  }

  function viewProductUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t(
              isEdit
                ? 'EDIT_PRODUCT'
                : isView
                  ? 'PRODUCT_DETAILS'
                  : 'ADD_PRODUCT'
            )}
            onBackClick={() => {
              navigate(-1);
            }}
            menus={getMenus()}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <BakeasyHeaderLabel message={'PRODUCT_DETAILS'} />
          </Grid>
          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText
                    label={t('PRODUCT_NAME')}
                    value={productName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText label={t('PRODUCT_ID')} value={productId} />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText label={t('SKU_NUMBER')} value={skuNumber} />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText label={t('PRODUCT_TYPE')} value={selectedProductType} />
                </Grid>

                 <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText label={t('RECIPE_BUILDER')} value={recipeBuilder} />
                </Grid> */}

                <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText
                    label={t('CATEGORY')}
                    value={selectedCategory?.categoryName}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText
                    label={t('SUBCATEGORY')}
                    value={selectedSubCategory?.subCategoryName}
                  />
                </Grid>

                {/* {recipeBuilder === 'Yes' && (
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                    <BakeasyLabelText label={t('RECIPE_BUILDER_TYPE')} value={recipeBuilderType} />
                  </Grid>
                )} */}

                <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText
                    label={t('STORE_COST') + getCurrency(_storeState?.value)}
                    value={storeCost}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                  <BakeasyLabelText
                    label={t('STATUS')}
                    value={
                      // selectedStatus
                      selectedStatus
                        ? t(
                            `${selectedStatus?.toUpperCase().replace(/\s+/g, '_')}`
                          )
                        : selectedStatus
                    }
                  />
                </Grid>
                {recipeBuilder === 'No' && (
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={6}>
                    <BakeasyLabelText
                      label={
                        t('GENERAL_PRODUCT_COST') +
                        getCurrency(_storeState?.value)
                      }
                      value={productCost}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <BakeasyLabelText
                    label={t('DESCRIPTION')}
                    value={description}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 0.2 }} pl={2}>
            {selectedProductImageFile && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <BakeasyImgSelectorView
                  uploadState="initFromProps"
                  disabled={true}
                  id="productImage"
                  value={selectedProductImageFile}
                  label={t('PRODUCT_IMAGE')}
                  name="product-image"
                  headerText={t('ACCEPTED_FORMATS')}
                  footerText={t('PLEASE_UPLOAD')}
                  onChange={(file: any) => {}}
                  onClick={() =>
                    openImageDialog(
                      'ViewImage',
                      t('PRODUCT_IMAGE'),
                      selectedProductImageFile
                    )
                  }
                />
              </Grid>
            )}
          </Grid>
          {/* // working but commented as client requested 1048 */}
          {/*
          <BakeasyDivider />

           {selectedProductType === 'Manufactured' && recipeBuilder === 'Yes' && (
            <>
              <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('INGREDIENTS')} />
              </Grid>

              {!isView && (
                <Grid container spacing={2} sx={{ display: 'flex', pl: 2 }}>
                  <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                    <Dropdown.Category
                      disabled={isView || recipeBuilder === 'No'}
                      size="small"
                      label={t('INGREDIENT_NAME')}
                      placeholder={t('SELECT_INGREDIENT')}
                      fullWidth={true}
                      value={ingredientName}
                      options={[]}
                      onChange={(event: SelectChangeEvent<HTMLSelectElement>) => {
                        setIngredientName(event?.target?.value);
                      }}
                      statusOptions={[]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                    <BakeasySelectLabel
                      fullWidth={true}
                      disabled={isView || recipeBuilder === 'No'}
                      label={t('UNIT_OF_MEASURE')}
                      statusOptions={unitsOfMeasureOptions}
                      placeholder="Select unit of measure"
                      size="small"
                      value={unitsOfMeasure}
                      onChange={(event: any) => setUnitsOfMeasure(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                    <BakeasyTextField
                      label={t('QUANTITY_PER_UNIT')}
                      disabled={isView || recipeBuilder === 'No'}
                      type="text"
                      placeHolder={'Enter Quantity Per Unit'}
                      name="ingQuantity"
                      fullWidth={true}
                      value={ingQuantity}
                      onChange={(event: any) => {
                        setIngQuantity(event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                    <BakeasyTextField
                      label={t('COST_PRICE')}
                      disabled={isView || recipeBuilder === 'No'}
                      type="text"
                      placeHolder={'Enter Cost price'}
                      name="price"
                      value={price}
                      fullWidth={true}
                      onChange={(event: any) => {
                        setPrice(event.target.value);
                      }}
                    />
                  </Grid>
                </Grid>
              )}

              {selectedProductType === 'Manufactured' && recipeBuilder === 'Yes' && (
                <>
                  <Grid container pl={2}>
                    {ingredientList?.length > 0 ? (
                      <BakeasySimpleTable
                        headers={ingredientTableHeadersForView}
                        tableData={ingredientList}
                      />
                    ) : (
                      <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
                    )}
                  </Grid>
                </>
              )}
            </>
          )} 

          {/* <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
            <BakeasyHeaderLabel message={t('OTHER_DETAILS')} />
          </Grid>
          <Grid container spacing={2} sx={{ pl: 2 }}>
            {selectedIngredientImage && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Paper component={Card} variant="outlined" sx={{ p: 1 }}>
                  <BakeasyImgSelectorView
                    uploadState="initFromProps"
                    disabled={true}
                    id="ingredientImage"
                    value={selectedIngredientImage}
                    label={t('INGREDIENT_IMAGE')}
                    name="ingredientImage"
                    headerText={t('ACCEPTED_FORMATS')}
                    footerText={t('PLEASE_UPLOAD')}
                    onChange={(file: any) => {}}
                    onClick={() =>
                      openImageDialog('ViewImage', t('INGREDIENT_IMAGE'), selectedIngredientImage)
                    }
                  />
                </Paper>
              </Grid>
            )}

            {selectedNutritionImage && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Paper component={Card} variant="outlined" sx={{ p: 1 }}>
                  <BakeasyImgSelectorView
                    uploadState="initFromProps"
                    disabled={true}
                    id="nutritionImage"
                    value={selectedNutritionImage}
                    label={t('NUTRITION_IMAGE')}
                    name="nutritionImage"
                    headerText={t('ACCEPTED_FORMATS')}
                    footerText={t('PLEASE_UPLOAD')}
                    onChange={(file: any) => {}}
                    onClick={() =>
                      openImageDialog('ViewImage', t('NUTRITION_IMAGE'), selectedNutritionImage)
                    }
                  />
                </Paper>
              </Grid>
            )}

            {skuImage && skuNumber && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Paper component={Card} variant="outlined" sx={{ p: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item>
                      <BakeasyLabelText label={t('SKU_NUMBER')} value={skuNumber} />
                    </Grid>
                    <Grid item>
                      <BakeasyImgSelectorView
                        uploadState="initFromProps"
                        disabled={true}
                        id="skuImage"
                        value={skuImage}
                        label={t('SKU_IMAGE')}
                        name="skuImage"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {}}
                        onClick={() => openImageDialog('ViewImage', t('SKU_IMAGE'), skuImage)}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            )}

            {!skuImage && skuNumber && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Paper component={Card} variant="outlined" sx={{ p: 1 }}>
                  <Grid>
                    <BakeasyLabelText label={t('SKU_NUMBER')} value={skuNumber} />
                  </Grid>
                </Paper>
              </Grid>
            )}

            {qrCode && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Paper component={Card} variant="outlined" sx={{ p: 1 }}>
                  <BakeasyImgSelectorView
                    uploadState="initFromProps"
                    disabled={true}
                    id="qrCode"
                    value={qrCode}
                    label={t('QR_CODE')}
                    name="qrCode"
                    headerText={t('ACCEPTED_FORMATS')}
                    footerText={t('PLEASE_UPLOAD')}
                    onChange={(file: any) => {}}
                    onClick={() => openImageDialog('ViewImage', t('QR_CODE'), qrCode)}
                  />
                </Paper>
              </Grid>
            )}
          </Grid> */}
        </Paper>
      </Grid>
    );
  }

  return isView ? viewProductUI() : <></>;
};
